import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PromanStateService } from '../services/proman-state.service';
import { CurrUser } from '@proman/interfaces/object-interfaces';

@Component({
    selector: 'pm-default-route',
    template: `

    `,
    standalone: false
})

export class DefaultRouteComponent {
    private Router = inject(Router);
    private PromanState = inject(PromanStateService);

    currUser: CurrUser;

    constructor() {


        this.PromanState.getAllowedState();
    }

}
